var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 16",
    focusable: "false"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cc_svg__cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cc_svg__Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    rx: 1.61,
    ry: 1.61,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc_svg__cls-2",
    d: "M28.39 1.2a.41.41 0 01.41.41v12.78a.41.41 0 01-.41.41H1.61a.41.41 0 01-.41-.41V1.61a.41.41 0 01.41-.41h26.78m0-1.2H1.61A1.61 1.61 0 000 1.61v12.78A1.61 1.61 0 001.61 16h26.78A1.61 1.61 0 0030 14.39V1.61A1.61 1.61 0 0028.39 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc_svg__cls-2",
    d: "M11.17 12.62a4.41 4.41 0 01-3.35-1.22 4.91 4.91 0 01-1.15-3.47 5.44 5.44 0 01.35-2A4.38 4.38 0 018 4.45a4 4 0 011.45-.92 5.51 5.51 0 011.84-.31 5.6 5.6 0 011 .09 6.09 6.09 0 01.81.19 3.47 3.47 0 01.59.23l.34.18-.59 1.64a4.56 4.56 0 00-1-.38A4.71 4.71 0 0011.25 5a2.91 2.91 0 00-.92.15 2 2 0 00-.79.5 2.54 2.54 0 00-.54.91 3.75 3.75 0 00-.21 1.33 4.34 4.34 0 00.14 1.16 2.36 2.36 0 00.44.93 2.08 2.08 0 00.8.62 2.87 2.87 0 001.19.23 4.83 4.83 0 00.8-.06 4.55 4.55 0 00.62-.12 3.85 3.85 0 00.48-.16l.38-.17.56 1.62a4.62 4.62 0 01-1.21.47 7 7 0 01-1.82.21zM20.31 12.62A4.41 4.41 0 0117 11.4a4.91 4.91 0 01-1.15-3.47 5.44 5.44 0 01.35-2 4.38 4.38 0 011-1.48 4 4 0 011.45-.92 5.72 5.72 0 012.87-.22 5.91 5.91 0 01.82.19 3.47 3.47 0 01.59.23l.34.18-.59 1.64a4.56 4.56 0 00-1-.38A4.76 4.76 0 0020.39 5a2.91 2.91 0 00-.92.15 2 2 0 00-.79.5 2.54 2.54 0 00-.55.89 3.75 3.75 0 00-.21 1.33 4.34 4.34 0 00.14 1.16 2.36 2.36 0 00.44.93 2.08 2.08 0 00.8.62 2.84 2.84 0 001.19.23 4.83 4.83 0 00.8-.06 4.55 4.55 0 00.62-.12 3.85 3.85 0 00.48-.16l.38-.17.56 1.62a4.62 4.62 0 01-1.21.47 7 7 0 01-1.81.23z"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/media/cc.svg";
export { SvgCc as ReactComponent };